import { default as Configuracoes } from './Configuracoes';
import { default as Perfil } from './Perfil';
import * as Gerenciamento from './Gerenciamento';
import * as Organizacao from './Organizacao';

export default {
  Perfil,
  Configuracoes,
  Gerenciamento,
  Organizacao,
};
